import { actionCreatorAsync } from "../../../store/utils";

export const requestResetPassword = actionCreatorAsync<string, {done: boolean;}, any>(
    'MEDAPP_CONTRACTOR', 'USER_ACTIVITIES', 'REQUEST_RESET_PASSWORD'
);


export const verifyOtp = actionCreatorAsync<{otp: string; password: string}, {verified: boolean; validOtp: string;}, any>(
    'MEDAPP_CONTRACTOR', 'USER_ACTIVITIES', 'VERIFY_OTP'
);

export const  resetPassword = actionCreatorAsync<string, {done: boolean;}, any>(
    'MEDAPP_CONTRACTOR', 'USER_ACTIVITIES', 'RESET_PASSWORD'
);
